import { render, staticRenderFns } from "./quick-actions.vue?vue&type=template&id=58e0192a"
import script from "./quick-actions.vue?vue&type=script&lang=js"
export * from "./quick-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports